import { useCallback, useContext } from 'react';
import _ from 'lodash';

import ReportGadgetsContext from 'contexts/ReportGadgetsContext';
import ReportsContext from 'contexts/ReportsContext';
import cardTypeCheckers from 'types/cardTypeCheckers';
import filterPlateTypeCheckers from 'types/filterPlateTypeCheckers';

import isFilterUsedInChart from '../isFilterUsedInChart';
import useGetIsUsedInMetricId from './useGetIsUsedInMetricId';

const useGetReportUsage = () => {
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);
  const { allReports } = useContext(ReportsContext);
  const getIsUsedInMetricId = useGetIsUsedInMetricId();

  const getReportUsage = useCallback(
    (filter: SavedFilter): FleetOps.MetricReportUsage[] => {
      const usage: FleetOps.MetricReportUsage[] = [];
      allReports.forEach((r) => {
        if (
          r.drillDowns?.find(
            (plate) =>
              filterPlateTypeCheckers.isSavedFilter(plate) &&
              plate.datasetFilterId === filter.id,
          ) ||
          r.scope.find(
            (plate) =>
              filterPlateTypeCheckers.isSavedFilter(plate) &&
              plate.datasetFilterId === filter.id,
          )
        ) {
          usage.push({
            id: r.id,
            reportId: r.id,
            reportName: r.name,
          });
        }

        r.canvas.cards.forEach((card) => {
          let chartDef: VisualisationDefinition | undefined;

          if (cardTypeCheckers.isChartDefinition(card)) {
            chartDef =
              reportGadgetsLookup[card.content.chartDefinitionId]?.chartDef;
          } else if (cardTypeCheckers.isReportGadget(card)) {
            chartDef =
              reportGadgetsLookup[card.content.reportGadgetId]?.chartDef;
          }

          if (!chartDef) {
            return;
          }

          if (isFilterUsedInChart(filter, chartDef, getIsUsedInMetricId)) {
            usage.push({
              id: `${chartDef.id}-${r.id}`,
              gadgetName: chartDef.name,
              gadgetId: chartDef.id,
              reportId: r.id,
              reportName: r.name,
            });
          }
        });
      });

      return _.uniqBy(usage, 'id');
    },
    [allReports, getIsUsedInMetricId, reportGadgetsLookup],
  );

  return getReportUsage;
};

export default useGetReportUsage;
